module.exports = require("@swa-ui/placements/src/ButtonGroupAdapter/ButtonGroupAdapter.module.scss");